import React from 'react'
import ReactDOM from 'react-dom'

export default class bb_dropdown extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isOpen: false,
            ourWidth: 0,
            dropDownPosTop: 0,
            dropDownPosLeft: 0,
            offSet: 0,
            remove: false,
            align: 'left',
            screenWidth: document.documentElement.clientWidth || document.body.clientWidth,
            ourDd: null
        }

        this.handleClick = this.handleClick.bind(this)
        this.checkListener = this.checkListener.bind(this)
        this.removeFromDom = this.removeFromDom.bind(this)
        this.outerCont = React.createRef()
        this.timer
        this.resizeHandler = this.resizeHandler.bind(this)
        this.fixDropdownPosition = this.fixDropdownPosition.bind(this)
        this.scrollHandler = this.scrollHandler.bind(this)
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.hasOwnProperty('isOpen') && this.props.isOpen !== this.state.isOpen) {
            this.setState({ isOpen: this.props.isOpen })
        }

        // isOpen can change either from the prop resync above (next commit) or
        // directly via state (e.g. handleClick closing it). Either way, once
        // it has actually committed we need to (re)bind or unbind the
        // document click listener for the new state.
        if (prevState.isOpen !== this.state.isOpen) {
            this.checkListener()
        }

        if (prevState.isOpen && !this.state.isOpen && this.props.removeOnClose) {
            if (this.timer) clearTimeout(this.timer)
            this.timer = setTimeout(this.removeFromDom, 300)
        }

        if (this.state.isOpen) {
            if (this.timer) clearTimeout(this.timer)
            this.setState({ remove: false })
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        // Previously this called setState from within shouldComponentUpdate to
        // trigger checkListener() after the isOpen commit. Scheduling a state
        // update from inside the render phase is not something React
        // guarantees the timing of, and under React 18 it meant the dropdown's
        // click listener (and therefore the "open" state) never reliably
        // landed. checkListener() now runs from componentDidUpdate instead.
        if (nextState.isOpen !== this.state.isOpen) return true
        if (nextProps !== this.props) return true
        if (this.state.align !== nextState.align) return true
        if (this.state.remove !== nextState.remove) return true
        return false
    }

    componentDidMount() {
        window.addEventListener('resize', this.resizeHandler.bind(this))
        var ourWidth = this.outerCont.current.offsetWidth
        var dropDownPosTop = this.outerCont.current.getBoundingClientRect().top + 1
        var dropDownPosLeft = this.outerCont.current.getBoundingClientRect().left

        this.setState(
            {
                isOpen: this.props.hasOwnProperty('isOpen') ? !!this.props.isOpen : true,
                ourWidth: ourWidth,
                ourDd: this.outerCont.current,
                dropDownPosTop: dropDownPosTop,
                dropDownPosLeft: dropDownPosLeft
            },
            () => {
                this.checkListener()
            }
        )
    }

    removeFromDom() {
        this.setState({ remove: true })
    }

    checkListener() {
        if (this.state.isOpen === true) {
            // Bind on the next tick rather than synchronously. checkListener()
            // runs inside the same click that opened the dropdown (openPop ->
            // setState -> componentDidUpdate), and the native click is still
            // bubbling up toward `document` at that point. A listener added
            // mid-dispatch still fires for the rest of that same event's
            // propagation, so binding synchronously here means the opening
            // click itself immediately re-triggers handleClick and closes the
            // dropdown again - it looks like the dropdown never opens.
            if (this.bindClickTimer) clearTimeout(this.bindClickTimer)
            this.bindClickTimer = setTimeout(() => {
                document.addEventListener('click', this.handleClick, false)
            }, 0)
            window.addEventListener('scroll', this.scrollHandler, true) // Use capture phase to catch all scrolls
            // Use requestAnimationFrame to ensure dropdown is rendered before calculating position
            requestAnimationFrame(() => {
                // Double RAF to ensure layout is complete
                requestAnimationFrame(() => {
                    this.fixDropdownPosition()
                })
            })
        } else {
            if (this.bindClickTimer) clearTimeout(this.bindClickTimer)
            document.removeEventListener('click', this.handleClick, false)
            window.removeEventListener('scroll', this.scrollHandler, true)
        }
    }

    componentWillUnmount() {
        if (this.bindClickTimer) clearTimeout(this.bindClickTimer)
        document.removeEventListener('click', this.handleClick, false)
        window.removeEventListener('scroll', this.scrollHandler, true)
        window.removeEventListener('resize', this.resizeHandler)
        if (this.timer) clearTimeout(this.timer)
        if (this.scrollTimer) clearTimeout(this.scrollTimer)
    }

    handleClick(e) {
        //prevents parent click if needed
        if (this.props.preventDefault === true) {
            e.stopPropagation()
            e.preventDefault()
        }
        if (
            !ReactDOM.findDOMNode(this).contains(e.target) ||
            (e.target.localName === 'a' && !this.props.preventAutoClose)
        ) {
            this.setState({ isOpen: false })
            this.props.onClose(this.props.id)
        }
    }

    fixDropdownPosition() {
        if (this.props.usePortal) {
            return
        }
        if (!this.state.ourDd) return

        let viewportWidth = window.innerWidth || document.documentElement.clientWidth

        const viewportPadding = 50

        const ddRect = this.state.ourDd.getBoundingClientRect()
        let dropdownWidth = ddRect.width || this.state.ourWidth
        let dropdownLeft = ddRect.left
        let dropdownRight = dropdownLeft + dropdownWidth

        if (this.props.dropDownParentProperties && this.props.dropDownParentProperties.width) {
            viewportWidth = this.props.dropDownParentProperties.width
            dropdownLeft = dropdownLeft - this.props.dropDownParentProperties.xPos
            dropdownRight = dropdownRight - this.props.dropDownParentProperties.xPos
        }

        if (dropdownLeft < 0) {
            this.setState({ align: 'left' })
        }
        if (dropdownRight > viewportWidth - viewportPadding) {
            this.setState({ align: 'right' })
        }
    }

    resizeHandler() {
        let documentWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
        this.setState({ screenWidth: documentWidth, ourDd: this.outerCont.current }, () => {
            if (this.state.isOpen) {
                // Use requestAnimationFrame to ensure DOM has updated
                requestAnimationFrame(() => {
                    this.fixDropdownPosition()
                })
            }
        })
    }

    scrollHandler() {
        if (this.state.isOpen) {
            // Debounce scroll events for performance
            if (this.scrollTimer) clearTimeout(this.scrollTimer)
            this.scrollTimer = setTimeout(() => {
                requestAnimationFrame(() => {
                    this.fixDropdownPosition()
                })
            }, 10)
        }
    }

    render() {
        var theStyle = this.props.style ? JSON.parse(JSON.stringify(this.props.style)) : {}
        if (this.props.top) {
            theStyle.top = this.props.top
        }

        if (this.props.width) {
            theStyle.width = this.props.width
        }

        if (this.state.align === 'left') {
            theStyle.left = 0
            theStyle.right = 'unset'
            theStyle.transform = 'none'
        }
        if (this.state.align === 'right') {
            theStyle.right = 0
            theStyle.left = 'unset'
            theStyle.transform = 'none'
        }
        if (this.state.align === 'center') {
            theStyle.left = '50%'
            theStyle.right = 'unset'
            theStyle.transform = 'translateX(-50%)'
        }

        theStyle.display = 'none'
        if (this.state.isOpen === true || this.props.hasOwnProperty('isOpen')) {
            theStyle.display = this.props.display || 'block'
        }

        let classes = 'topnav-dropdown ' + this.props.className + ' '
        if (this.state.isOpen) classes += ' open'

        if (!this.state.isOpen) {
            theStyle.display = 'none'
            theStyle.visibility = 'hidden'
            if (this.props.align === 'left') {
                theStyle.left = '0'
            }
            if (this.props.align === 'right') {
                theStyle.right = '0'
            }
        }

        if (this.props.usePortal) {
            theStyle.top = this.state.dropDownPosTop
            theStyle.left = this.state.dropDownPosLeft
            theStyle.position = 'fixed'
            theStyle.width = this.state.ourWidth
            return (
                <div className='pos-rel' ref={this.outerCont}>
                    {ReactDOM.createPortal(
                        <div style={theStyle} className={classes}>
                            {this.props.children}
                        </div>,
                        document.body
                    )}
                </div>
            )
        }

        return (
            <div className='pos-rel'>
                <div style={theStyle} className={classes} ref={this.outerCont}>
                    {this.props.children}
                </div>
            </div>
        )
    }
}
